<template>
  <div id="client" v-if="isAuthed" class="transparent">
    <cli-navigator ref="navigator"></cli-navigator>
    <cli-toolbar @emit="emitted"></cli-toolbar>
    <v-content>
      <v-container app fill-height>
        <router-view ref="main" />
      </v-container>
    </v-content>
  </div>
</template>

<script>
import CliToolbar from './toolbar'
import CliNavigator from './navigator'

export default {
  name: 'client',
  components: {
    CliToolbar,
    CliNavigator
  },
  data () {
    return {
      config: {
        status: {
          navigator: true,
          authed: false
        }
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init: function () {
      this.$firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          this.$author.auth(user).then(res => {
            const { author, authors } = res
            this.$store.commit('config/update', { authors })
            this.$store.commit('author/update', author)
            user.getIdToken(true).then(token => {
              this.axios.post(`${this.$url.api}client/init`, {
                id: this.$route.params.id,
                roles: author.roles
              }, {
                headers: {
                  'firebase-token': token
                }
              }).then(res => {
                console.log(res)
                if (res.data && res.data.success) {
                  this.$store.commit('client/update', res.data.data)
                  this.$set(document, 'title', res.data.data.name.join(' ') + ' - SASMANGO')
                  this.$set(this.config.status, 'authed', true)
                } else {
                  this.$router.push('/')
                }
              })
            })
          }).catch(err => {
            console.log(err)
            this.unauthed()
          })
        } else {
          this.unauthed()
        }
      })
    },
    initSocket: function (token) {
    },
    unauthed: function () {
      let qs = this.$route.query
      this.$router.push({
        path: '/login',
        query: {
          redirect: 'redirect' in qs ? qs.redirect : this.$route.fullPath
        }
      })
    },
    emitted: function (req) {
      if (
        req &&
        req.dest &&
        req.action &&
        this.$refs[req.dest] &&
        typeof this.$refs[req.dest][req.action] === 'function'
      ) {
        this.$refs[req.dest][req.action](req.data)
      }
    }
  },
  computed: {
    isAuthed () {
      return this.config.status.authed
    }
  }
}
</script>

<style lang="scss">
#client {
  width: 100%;
  min-height: 100vh;
  .v-content {
    min-height: 100vh;
    .container.app {
      & > main {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
